import { render, staticRenderFns } from "./BaseFormPopupWrappable.vue?vue&type=template&id=4a21ee60&scoped=true&lang=pug&"
import script from "./BaseFormPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./BaseFormPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormPopupWrappable.vue?vue&type=style&index=0&id=4a21ee60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a21ee60",
  null
  
)

export default component.exports